export const advancedShippingNoticeGridProperties = {
  name: 'name',
  dateCreated: 'dateCreated',
  dateLastUpdated: 'dateLastUpdated',
  dateSubmitted: 'dateSubmitted',
  status: 'status',
  actions: 'actions',
};
